// import React, { useState, useEffect } from 'react'
// import UploadCateogrymodels from '../Component/UploadCateogrymodels'
// import Axios from '../Utils/axios'
// import SummaryAPI from '../Commson/summaryApi'
// import EditCategory from '../Component/EditCategory'
// import ConfirmBox from '../Component/ConfirmBox'
// import { AxiosToastError } from '../Utils/AxiosToastError'
// import toast from 'react-hot-toast'
// import { useSelector } from 'react-redux'

// const Category = () => {
//   const [openuploadCaetegory, setOpenUploadCategory] = useState(false)
//   const [loading, setLoading] = useState(false)
//   const [categories, setCategories] = useState([])

//   const [openEdit, setopenedit] = useState(false)
//   const [editData, setEditData] = useState({ name: "", image: "" })

//   const [openConfirmBoxDelete, setopenConfirmBoxDelete] = useState(false)
//   const [deleteCategory, setDeleteCategory] = useState({ _id: "" })

//   // const fetchCategory = async () => {
//   //   try {
//   //     setLoading(true)
//   //     const response = await Axios({ ...SummaryAPI.getAllCategories })
//   //     const { data: responseData } = response

//   //     if (responseData.success) {
//   //       setCategories(responseData.data)
//   //     }
//   //   } catch (error) {
//   //     console.error("Error fetching categories", error)
//   //   } finally {
//   //     setLoading(false)
//   //   }
//   // }
  
//   // useEffect(() => {
//   //   fetchCategory()
//   // }, [])

//   const allCategory = useSelector((state) => state.product.allCategory)
//   useEffect(() => {
//     setCategories(allCategory)
//   }, [allCategory])


//   const handleDeleteCategory = async (id) => {
//     try {
//       const response = await Axios({
//         ...SummaryAPI.deleteCategory,
//         data: deleteCategory
//       })

//       if (response.data.success) {
//         toast.success(response.data.message)
//         fetchCategory()
//       }
//     } catch (error) {
//       AxiosToastError(error)
//     } finally {
//       setopenConfirmBoxDelete(false)
//     }
//   }


//   return (
//     <section className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 p-4 sm:p-6">
//       {/* Header Section */}
//       <div className="bg-white shadow-md sm:shadow-lg rounded-lg sm:rounded-xl px-4 sm:px-6 py-3 sm:py-4 flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-0">
//         <h2 className="text-xl sm:text-2xl font-bold text-gray-800 tracking-wide text-center sm:text-left">
//           📂 Category Management
//         </h2>
//         <button
//           onClick={() => setOpenUploadCategory(true)}
//           className="bg-indigo-600 text-white px-4 sm:px-5 py-2 rounded-lg shadow-md hover:bg-indigo-700 active:scale-95 transition-all duration-200 ease-in-out w-full sm:w-auto"
//         >
//           + Add Category
//         </button>
//       </div>

//       {/* Category Content Section */}
//       {loading ? (
//         <div className="flex flex-col items-center justify-center mt-10">
//           <div className="w-10 h-10 sm:w-12 sm:h-12 border-4 border-indigo-500 border-t-transparent rounded-full animate-spin"></div>
//           <p className="mt-4 text-gray-600 font-medium text-sm sm:text-base">Loading categories...</p>
//         </div>
//       ) : categories.length === 0 ? (
//         <div className="text-center text-gray-500 mt-10">
//           <p className="text-base sm:text-lg">No categories added yet</p>
//           <p className="text-xs sm:text-sm mt-1">
//             Click{" "}
//             <span className="font-semibold text-indigo-600">+ Add Category</span>{" "}
//             to create one.
//           </p>
//         </div>
//       ) : (
//         <div className="grid gap-4 sm:gap-6 grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 mt-8">
//           {categories.map((cat) => (
//             <div
//               key={cat._id}
//               className="bg-white shadow-sm sm:shadow-md rounded-lg sm:rounded-xl overflow-hidden hover:shadow-lg transition duration-200 flex flex-col"
//             >
//               <img
//                 src={cat.image}
//                 alt={cat.name}
//                 className="w-full h-28 sm:h-40 object-contain bg-gray-50"
//               />
//               <div className="p-3 sm:p-4 text-center flex-1 flex flex-col justify-between">
//                 <h3 className="text-sm sm:text-lg font-semibold text-gray-800 truncate mb-3">
//                   {cat.name}
//                 </h3>
//                 <div className="flex justify-center gap-2">
//                   <button
//                     onClick={() => { setopenedit(true); setEditData(cat) }}
//                     className="bg-blue-500 hover:bg-blue-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md shadow"
//                   >
//                     Edit
//                   </button>
//                   <button
//                     onClick={() => { setopenConfirmBoxDelete(true); setDeleteCategory(cat) }}
//                     className="bg-red-500 hover:bg-red-600 text-white text-xs sm:text-sm px-3 py-1 rounded-md shadow"
//                   >
//                     Delete
//                   </button>
//                 </div>
//               </div>
//             </div>
//           ))}
//         </div>
//       )}

//       {/* Add Category Modal */}
//       {openuploadCaetegory && (
//         <UploadCateogrymodels fetchData={fetchCategory} close={() => setOpenUploadCategory(false)} />
//       )}

//       {/* Edit Category Modal */}
//       {openEdit && (
//         <EditCategory data={editData} fetchData={fetchCategory} close={() => setopenedit(false)} />
//       )}

//       {/* Confirm Delete Modal */}
//       {openConfirmBoxDelete && (
//         <ConfirmBox
//           cancle={() => setopenConfirmBoxDelete(false)}
//           confirm={() => handleDeleteCategory(deleteCategory._id)}
//           close={() => setopenConfirmBoxDelete(false)}
//         />
//       )}
//     </section>
//   )
// }

// export default Category


import React from 'react'

const Category = () => {
  return (
    <div>Category</div>
  )
}

export default Category